function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Table, Form, Button, DatePicker, Select, message, Divider, Collapse, Skeleton, Drawer, Space, notification, Statistic } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from './includes/Common';
import { NodePlusFill, Search, FuelPumpFill } from "react-bootstrap-icons";
import { Icon } from "@iconify/react";
import dayjs from 'dayjs';
import Moment from 'react-moment';
import moment from 'moment';
import AddPumpReport from './forms/AddPumpReport';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var PumpReportsHistory = function PumpReportsHistory() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    reportList = _useState2[0],
    setReportList = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    reportArrayData = _useState4[0],
    setReportArrayData = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showAddPumpReport = _useState6[0],
    setShowAddPumpReport = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    agentOptions = _useState8[0],
    setAgentOptions = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isFormLoading = _useState10[0],
    setIsFormLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataChanged = _useState12[0],
    setIsDataChanged = _useState12[1];
  var _useState13 = useState(moment().startOf('day').format()),
    _useState14 = _slicedToArray(_useState13, 2),
    from = _useState14[0],
    setFrom = _useState14[1];
  var _useState15 = useState(moment().endOf('day').format()),
    _useState16 = _slicedToArray(_useState15, 2),
    to = _useState16[0],
    setTo = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedStationId = _useState18[0],
    setSelectedStationId = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedStation = _useState20[0],
    setSelectedStation = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    stationsList = _useState22[0],
    setStationsList = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    stationsOptions = _useState24[0],
    setStationsOptions = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    isDataLoading = _useState26[0],
    setIsDataLoading = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    totalForDeposit = _useState28[0],
    setTotalForDeposit = _useState28[1];
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    totalTotalDeposit = _useState30[0],
    setTotalDeposit = _useState30[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Agent"
    }),
    dataIndex: 'agent',
    key: 'agent',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Ind. D\xE9p."
    }),
    dataIndex: 'indexStart',
    key: 'indexStart',
    responsive: ['lg', 'md'],
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Ind. Arv."
    }),
    dataIndex: 'indexEnd',
    responsive: ['lg', 'md'],
    key: 'indexEnd',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "A d\xE9poser"
    }),
    dataIndex: 'total',
    key: 'total',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9pos\xE9"
    }),
    dataIndex: 'amount',
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Ecart"
    }),
    dataIndex: 'ecart',
    key: 'ecart',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        style: {
          color: parseInt(text) < 0 ? "#B8423C" : "#363333"
        },
        children: text.toLocaleString('Fr')
      });
    }
  }];
  var handleStationChange = function handleStationChange(v) {
    setSelectedStationId(v);
    setSelectedStation(stationsList.filter(function (s) {
      return s.id == v;
    })[0]);
    setIsDataChanged(true);
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    var request = values.agent_id == 0 ? axios.get("".concat(Common.baseApiUrl, "getpumpreports/").concat(Common.currentUser.id, "/").concat(moment(values.period[0].$d).format(), "/").concat(moment(values.period[1].$d).format())) : axios.get("".concat(Common.baseApiUrl, "getpumpreports/").concat(values.agent_id, "/").concat(Common.currentUser.id, "/").concat(moment(values.period[0].$d).format(), "/").concat(moment(values.period[1].$d).format()));
    request.then(function (response) {
      if (response.data.status == 200) {
        setReportArrayData([]);
        setReportList(response.data.reports);
        response.data.reports.forEach(function (r) {
          setReportArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: r.id,
              date: r.created_at,
              agent: "".concat(r.agent.prenom, " ").concat(r.agent.nom),
              indexStart: r.indexStart,
              indexEnd: r.indexEnd,
              total: (r.indexEnd - r.indexStart) * r.product.base_price,
              amount: r.total_cash + r.total_coupon,
              ecart: r.total_cash + r.total_coupon - (r.indexEnd - r.indexStart) * r.product.base_price
            }]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    setIsDataChanged(false);
    setTotalDeposit(0);
    setTotalForDeposit(0);
    axios.all([axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id), axios.get("".concat(Common.baseApiUrl, "getpumpreports/").concat(Common.currentUser.id, "/").concat(from, "/").concat(to))]).then(function (response) {
      if (response[0].data.status == 200) {
        setAgentOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: 'Tous les agents',
            value: 0
          }]);
        });
        response[0].data.users.filter(function (u) {
          return u.role == 401;
        }).forEach(function (u) {
          setAgentOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: u.prenom + " " + u.nom,
              value: u.id
            }]);
          });
        });
        form.setFieldsValue({
          agent_id: 0
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setReportArrayData([]);
        setReportList(response[1].data.reports);
        setTotalDeposit(0);
        setTotalForDeposit(0);
        response[1].data.reports.forEach(function (r) {
          setReportArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: r.id,
              date: r.created_at,
              agent: "".concat(r.agent.prenom, " ").concat(r.agent.nom),
              indexStart: r.indexStart,
              indexEnd: r.indexEnd,
              total: (r.indexEnd - r.indexStart) * r.product.base_price,
              amount: r.total_cash + r.total_coupon,
              ecart: r.total_cash + r.total_coupon - (r.indexEnd - r.indexStart) * r.product.base_price
            }]);
          });
          setTotalForDeposit(function (prev) {
            return prev + (r.indexEnd - r.indexStart) * r.product.base_price;
          });
          setTotalDeposit(function (prev) {
            return prev + (r.total_cash + r.total_coupon);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ',
        delay: 5
      });
    })["finally"](function () {});
  }, [isDataChanged, selectedStation]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Space, {
      direction: "vertical",
      children: /*#__PURE__*/_jsx(Button, {
        style: {
          marginBottom: 12
        },
        loading: isFormLoading,
        icon: /*#__PURE__*/_jsx(NodePlusFill, {}),
        type: "link",
        onClick: function onClick() {
          setShowAddPumpReport(true);
        },
        children: /*#__PURE__*/_jsx("b", {
          children: " SAISIR UN RAPPORT"
        })
      })
    }), /*#__PURE__*/_jsx(Collapse, {
      ghost: true,
      items: [{
        key: 1,
        label: /*#__PURE__*/_jsx("b", {
          children: "Filtrer par p\xE9riode"
        }),
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(Form, {
            onFinish: onFinish,
            form: form,
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 5,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "period",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(RangePicker, {
                    showTime: true,
                    format: "DD/MM/YYYY HH:mm:ss",
                    presets: [{
                      label: 'Hier',
                      value: dayjs().add(-1, 'd')
                    }, {
                      label: "Aujourdh'hui",
                      value: dayjs().add(0, 'd')
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "agent_id",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Select, {
                    options: agentOptions
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isFormLoading,
                    type: "primary",
                    icon: /*#__PURE__*/_jsx(Search, {}),
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsx("b", {
                      children: " Rechercher"
                    })
                  })
                })
              })]
            })
          })
        })
      }]
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 4,
        md: 4,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            borderRadius: "7px",
            padding: "22px 18px",
            marginBottom: "8px",
            textAlign: "center",
            background: "#A8675C"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            prefix: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:sales-performance",
              width: "48",
              height: "48"
            }),
            valueStyle: {
              color: "#EEE"
            },
            title: /*#__PURE__*/_jsx("b", {
              style: {
                color: '#EEE'
              },
              children: "Total Vente"
            }),
            value: totalForDeposit
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 4,
        md: 4,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            borderRadius: "7px",
            padding: "22px 18px",
            marginBottom: "8px",
            textAlign: "center",
            background: "#A8825C"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            prefix: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:money-transfer",
              width: "48",
              height: "48"
            }),
            valueStyle: {
              color: "#EEE"
            },
            title: /*#__PURE__*/_jsx("b", {
              style: {
                color: '#EEE'
              },
              children: "Total D\xE9pos\xE9"
            }),
            value: totalTotalDeposit
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 4,
        md: 4,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            borderRadius: "7px",
            padding: "22px 18px",
            marginBottom: "8px",
            textAlign: "center",
            background: "#5C76A8"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            prefix: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:high-priority",
              width: "48",
              height: "48"
            }),
            valueStyle: {
              color: "#EEE"
            },
            title: /*#__PURE__*/_jsx("b", {
              style: {
                color: '#EEE'
              },
              children: "Ecart"
            }),
            value: totalForDeposit - totalTotalDeposit
          })
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsxs("b", {
          children: ["Du ", /*#__PURE__*/_jsx(Moment, {
            date: from,
            format: "DD/MM/YYYY"
          }), " Au ", /*#__PURE__*/_jsx(Moment, {
            date: to,
            format: "DD/MM/YYYY"
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
          columns: cols,
          dataSource: reportArrayData,
          responsive: true,
          bordered: true,
          size: "small"
        })]
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(FuelPumpFill, {
            size: 24
          }), /*#__PURE__*/_jsx("b", {
            children: " RAPPORT DE POMPISTE"
          })]
        })
      }),
      width: "450px",
      open: showAddPumpReport,
      onClose: function onClose() {
        setShowAddPumpReport(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(AddPumpReport, {
        station: selectedStation,
        handler: function handler() {
          setShowAddPumpReport(false);
          setIsDataChanged(true);
          notification.success({
            message: "Ok!",
            description: "Opération enregistrée !"
          });
        }
      })
    })]
  });
};
export default PumpReportsHistory;